import {
    UPDATE_LD_FLAGS,
    UPDATE_LD_ID,
    UPDATE_LD_CLIENT
} from './types';

export const updateLdFlags = (data) => {
    return {
        type: UPDATE_LD_FLAGS,
        payload: data
    };
};

export const updateLdId = (data) => {
    return {
        type: UPDATE_LD_ID,
        payload: data
    };
};

export const updateStoreLdClient = (data) => {
    return {
        type: UPDATE_LD_CLIENT,
        payload: data
    };
};
